<template>
  <div class="col-md-12 p-0 mx-auto" style="border: none!important;">
    <h6>آگهی های دسته انتخابی</h6>
    <p class="text-muted">توجه! :برای انتخاب آگهی موردنظر روی هر سطر کلیک کنید.</p>

    <div>
      <v-autocomplete :items="remainingData.tabs" item-text="title" item-value="identifier"
                      @change="getRemainingData($event)" label="نوع فروشگاه"
                      v-model="remainingData.current"
                      outlined
                      prepend-inner-icon="fa fa-pencil-alt"
                      dense>
      </v-autocomplete>
    </div>

    <div class="d-md-flex d-lg-flex d-xl-flex px-0">
      <div class="col-md" style="font-size: 9pt">
        <p class="">شماره فروشگاه : <span
            class="font-weight-bold badge badge-info">{{ marketNumber }}</span></p>
      </div>

      <div class="col-md" style="font-size: 9pt">
        <p class="">تعداد آگهی انتخاب شده : <span
            class="font-weight-bold badge badge-info">{{ selectedAds.length }}</span></p>
      </div>

      <div class="col-md mr-auto">
        <p class="float-right" style="font-size: 9pt">حداکثر تعداد نردبان قابل استفاده : <span
            class="font-weight-bold badge badge-info">{{
            remainingData.remaining != null ? remainingData.remaining : 0
          }}</span>
        </p>
      </div>

      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="importAds" fab icon v-bind="attrs" v-on="on"><i class="fa fa-download text-info"></i></v-btn>
          </template>
          <span>بارگیری آگهی های فروشگاهی</span>
        </v-tooltip>
      </div>
    </div>
    <v-menu
        top
        :close-on-click="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            class="mb-5"
            color="primary"
            v-bind="attrs"
            v-on="on"
        >
          فیلترها
        </v-btn>
      </template>

      <v-list>
        <v-list-item
            v-for="(item, index) in selectList"
            :key="index"
            @click="filterSelections(item.value)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-data-table
        v-model="selectedAds"
        :headers="headers"
        :items="ownAds.data"
        :item-key="ownAds.data.manage_token"
        :search="search"
        :items-per-page="5"
        @click:row="rowClicked"
        align="center"
        :footer-props="{'items-per-page-text':'تعداد  ردیف  در هر صفحه',
                'items-per-page-options':[5,10, 30, 50, 100, -1],
                }"
        class="elevation-1 table-bordered table-hover table-striped p-4">

      <template v-slot:top>
        <div class="row mx-auto">
          <v-btn class="my-auto purple lighten-4" @click="selectAll">انتخاب همه</v-btn>
          <v-text-field
              v-model="search"
              label="جستجو"
              append-icon="mdi-magnify"
              dense
              class="mx-4 my-3 mt-4"
          ></v-text-field>
        </div>
      </template>
      <template v-slot:item="{ item }">
        <tr data-item="advertise" :class="selectedAds.indexOf(item.manage_token)> -1?'purple lighten-4':''"
            @click="rowClicked(item)">
          <td>{{ item.title }}</td>
          <td>{{ item.data }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.phone + ' ' + item.nickname }}</td>
        </tr>
      </template>
      
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} از {{ items.itemsLength }}
      </template>

    </v-data-table>
  </div>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import NumberSelector from "@/view/pages/ads/numberSelector";

export default {
  name: "shopAdsList",
  components: {NumberSelector, CreateDefault, TitleRibbon, button, dataTableProps, createTarefe},
  props: {
    category: {
      default: ''
    },
    city: {
      default: ''
    },
    neighborhood: {
      default: ''
    },
    all: {
      default: false,
    },
    ladder: {
      default: false,
    },
    marketNumber: {
      dafault: ''
    },
    marketNumberId: {
      default: ''
    }
  },
  data() {
    return {
      search: '',
      translates: [],
      selectList: [
        {title: 'انتخاب همه از بالا', value: 'top'},
        {title: 'انتخاب همه از پایین', value: 'bottom'},
        {title: 'انتخاب همه تصادفی', value: 'shuffle'},
        {title: 'انتخاب نردبان نشده ها', value: 'not gradual'},
        {title: 'انتخاب عدم نردبان بیش از 1 روز', value: '1more'},
        {title: 'انتخاب عدم نردبان بیش از 3 روز', value: '3more'},
        {title: ' انتخاب عدم نردبان بیش از 1 هفته', value: '7more'},
      ],
      ownAds: {},
      url: `${url}/advertise/post/own`,
      selectedAds: [],
      headers: [
        {text: 'عنوان', value: 'title'},
        {text: 'زمان انتشار', value: 'data'},
        {text: 'تعداد دفعات نردبان شده', value: 'price'},
        {text: 'شماره', value: 'phone'},
      ],
      remainingData: [],
      CurrentTab: ''
    }
  },
  methods: {
    getRemainingData(tabs) {
      this.CurrentTab = tabs
      $.ajax({
        url: `${url}/divar/market/remaining/${this.marketNumberId}?tab=${tabs}`,
        method: "POST",
        fn: this.getRemainingData,
        params: [tabs],
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (res) => {
          this.remainingData = res.data;
          this.ownAds = res.data
        }
      })
    },
    importAds() {
      $.ajax({
        url: `${url}/divar/market/import/${this.marketNumberId}`,
        method: "POST",
        fn: this.importAds,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        msg: false,
        success: (res) => {
          this.$nextTick(function () {
            this.$modal.success('بارگیری موفقیت آمیز!', 'بارگیری اگهی های شما موفقیت آمیز بود.')
          })
        }
      })
    },
    rowClicked(row) {
      this.toggleSelection(row.manage_token);
    },
    toggleSelection(keyID) {
      if (this.selectedAds.includes(keyID)) {
        this.selectedAds = this.selectedAds.filter(
            selectedKeyID => selectedKeyID !== keyID
        );
      } else {
        this.selectedAds.push(keyID);
      }
    },
    filterOnlyCapsText(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().indexOf(search) !== -1
    },
    selectAll() {
      $('[data-item]').each(function () {
        let rp = this;
        setTimeout(function () {
          rp.click()
        }, 250)
      });
    },
    async filterSelections(position) {
      switch (position) {
        case 'top':
          this.selectedAds = []
          this.selectAll();
          break;
        case 'bottom':
          this.selectedAds = []
          this.selectAll();
          this.selectedAds.reverse();
          break;
        case 'shuffle':
          this.selectedAds = []
          this.selectAll()
          if (this.selectedAds.length < this.ownAds.length)
            setTimeout(() => {
              this.selectedAds.sort(() => Math.random() - 0.5);
            }, 2500)
          break;
        case '1more':
          this.selectedAds = []
          const list = this.ownAds.data.filter(x => x.data.includes('روز') || x.data.includes('هفته'));

          for (const item of list) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }
          break;
        case '3more':
          this.selectedAds = []
          const lists = this.ownAds.data.filter(x => (x.data.includes('روز') || x.data.includes('هفته')) && (!x.data.includes('دیروز') && !x.data.includes('پریروز')));

          for (const item of lists) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }

          break;
        case 'not gradual':
          this.selectedAds = []
          const list8 = this.ownAds.data.filter(x => x.data.includes('نردبان نشده'));

          for (const item of list8) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }
          break;
        case '7more':
          this.selectedAds = []
          const list7 = this.ownAds.data.map(x => {
            return {
              ...x,
              data: this.english(x.data)
            }
          }).filter(x => (x.data.includes('روز') || x.data.includes('هفته')) && (!x.data.includes('دیروز') && !x.data.includes('پریروز')))
              .filter(x => x.data.includes('هفته') || x.data.match(/\d+/)?.[0] > 7);

          for (const item of list7) {
            this.toggleSelection(item.manage_token);
            await new Promise(resolve => setTimeout(resolve, 25))
          }

          break;

      }
    }

  },
  watch: {
    category: function () {
      Bus.$emit('getOwnAds', this.getMyAds())
    },
    selectedAds: {
      handler: function () {
        Bus.$emit('selectedAds', this.selectedAds)
      },
      deep: true
    },
    CurrentTab: {
      handler: function () {
        Bus.$emit('currentTab', this.CurrentTab)
      },
      deep: true
    },
    all: {
      handler: function () {
        this.ownAds = [];
        this.getMyAds()
      },
      deep: true
    },
    remainingData: {
      handler: function (val) {
        Bus.$emit('maxCountOfLadder', this.remainingData);
      },
      deep: true
    },

  },
  mounted() {
    this.getRemainingData('DEFAULT')
  },
}
</script>

<style>
table thead.v-data-table-header th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

table thead.v-data-table th {
  font-size: 15px !important;
  padding: 13px !important;
  text-align: right !important;
}

#list-item-294-5 .v-list-item__content .v-list-item__title {
  display: none;
}

#list-item-294-5 .v-list-item__content:after {
  content: 'همه';
}
</style>
